import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "sonner";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Guests from "@/pages/Guests";
import GuestDetail from "@/pages/GuestDetail";
import Bookings from "@/pages/Bookings";
import Rooms from "@/pages/Rooms";
import Invoices from "@/pages/Invoices";
import Tasks from "@/pages/Tasks";
import Messages from "@/pages/Messages";
import Automations from "@/pages/Automations";
import Statistics from "@/pages/Statistics";
import Insights from "@/pages/Insights";
import MonthlyJournalPage from "@/pages/MonthlyJournalPage";
import RatesAvailability from "@/pages/RatesAvailability";
import Settings from "@/pages/Settings";
import NIC from "@/pages/NIC";
import CheckIn from "@/pages/CheckIn";
import Reviews from "@/pages/Reviews";
import Approvals from "@/pages/Approvals";
import GuestPortal from "@/pages/GuestPortal";
import Breakfast from "@/pages/Breakfast";
import Meal from "@/pages/Meal";
import PublicCheckin from "@/pages/forms/PublicCheckin";
import PublicBreakfast from "@/pages/forms/PublicBreakfast";
import PublicMeal from "@/pages/forms/PublicMeal";
import PublicInquiry from "@/pages/forms/PublicInquiry";
import NICWidget from "@/pages/NICWidget";
import Inquiries from "@/pages/Inquiries";
import FormsCenter from "@/pages/FormsCenter";
import Schichtplan from "@/pages/Schichtplan";
import MenuOrder from "@/pages/MenuOrder";
import MenuEditor from "@/pages/MenuEditor";
import Ausgaben from "@/pages/Ausgaben";
import SteuerberaterPortal from "@/pages/SteuerberaterPortal";
import SteuerberaterVerwaltung from "@/pages/SteuerberaterVerwaltung";
import WhatsAppInbox from "@/pages/WhatsAppInbox";
import EmailInbox from "@/pages/EmailInbox";
import Backup from "@/pages/Backup";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null) return <div className="min-h-screen grid place-items-center text-muted-foreground">Lade…</div>;
  if (!user) return <Navigate to="/login" replace />;
  // Steuerberater sehen NUR das Portal
  if (user.role === "steuerberater") return <Navigate to="/steuerberater" replace />;
  return children;
}

function StbProtected({ children }) {
  const { user } = useAuth();
  if (user === null) return <div className="min-h-screen grid place-items-center text-muted-foreground">Lade…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role !== "steuerberater" && user.role !== "admin") return <Navigate to="/" replace />;
  return children;
}

export default function App() {
  return (
    <AuthProvider>
      <Toaster position="top-right" richColors />
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/checkin/:token" element={<CheckIn />} />
          <Route path="/check-in/:token" element={<CheckIn />} />
          <Route path="/fruehstueck/:token" element={<Breakfast />} />
          <Route path="/essen/:token" element={<Meal />} />
          <Route path="/gast/:token" element={<GuestPortal />} />
          {/* Öffentliche Formulare (Option B – ohne Token, für Strato-Embed) */}
          <Route path="/checkin" element={<PublicCheckin />} />
          <Route path="/fruehstueck" element={<PublicBreakfast />} />
          <Route path="/essen" element={<PublicMeal />} />
          <Route path="/anfrage" element={<PublicInquiry />} />
          <Route path="/buchungsanfrage" element={<PublicInquiry />} />
          <Route path="/inquiry" element={<PublicInquiry />} />
          <Route path="/nic-widget" element={<NICWidget />} />
          <Route path="/steuerberater" element={<StbProtected><SteuerberaterPortal /></StbProtected>} />
          <Route path="/" element={<Protected><Layout /></Protected>}>
            <Route index element={<Dashboard />} />
            <Route path="gaeste" element={<Guests />} />
            <Route path="gaeste/:id" element={<GuestDetail />} />
            <Route path="buchungen" element={<Bookings />} />
            <Route path="zimmer" element={<Rooms />} />
            <Route path="rechnungen" element={<Invoices />} />
            <Route path="statistik" element={<Statistics />} />
            <Route path="monatsjournal" element={<MonthlyJournalPage />} />
            <Route path="raten" element={<RatesAvailability />} />
            <Route path="insights" element={<Insights />} />
            <Route path="aufgaben" element={<Tasks />} />
            <Route path="nachrichten" element={<Messages />} />
            <Route path="automatisierungen" element={<Automations />} />
            <Route path="bewertungen" element={<Reviews />} />
            <Route path="freigaben" element={<Approvals />} />
            <Route path="nic" element={<NIC />} />
            <Route path="formulare" element={<FormsCenter />} />
            <Route path="anfragen" element={<Inquiries />} />
            <Route path="schichtplan" element={<Schichtplan />} />
            <Route path="menu-anpassen" element={<MenuOrder />} />
            <Route path="speisekarte" element={<MenuEditor />} />
            <Route path="ausgaben" element={<Ausgaben />} />
            <Route path="steuerberater-verwaltung" element={<SteuerberaterVerwaltung />} />
            <Route path="datensicherung" element={<Backup />} />
            <Route path="inbox" element={<WhatsAppInbox />} />
            <Route path="posteingang" element={<EmailInbox />} />
            <Route path="einstellungen" element={<Settings />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
